import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [data, setData] = useState(null);
  const [about, setAbout] = useState("");

  const [isExpanded, setIsExpanded] = useState(false);

  const words = about.split(" ");
  const isLong = words.length > 70;

  const displayText = isExpanded
    ? about
    : words.slice(0, 70).join(" ") + (isLong ? "..." : "");

  useEffect(() => {
    axios
      .get("https://rbbackend.onrender.com/api/content")
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    data?.map((val) => {
      if (val.section === "about") setAbout(val.content);
      return 0;
    });
  }, [data]);

  return (
    <div>
      <div id="footer-wrapper" className="footer-dark">
        <footer id="footer">
          <div className="container">
            <div className="row">
              <ul className="col-md-3 col-sm-6 footer-widget-container clearfix">
                <li className="widget widget_newsletterwidget">
                  <div className="title">
                    <img
                      className="mx-auto"
                      src="https://rbcorporationexport.netlify.app/assets/logo.png"
                      alt="Mateks - Natural Ingredients From The Best Fruits in Türkiye"
                      width="50%"
                      style={{
                        background: "#fff",
                        padding: "19px 10px",
                        marginBottom: "20px",
                        borderRadius: "0px 20px 0px 20px",
                      }}
                    />
                  </div>

                  <div className="clearfix"></div>
                  <p>
                    {displayText}
                    {isLong && (
                      <span
                        onClick={() => setIsExpanded(!isExpanded)}
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          marginLeft: "8px",
                        }}
                      >
                        {isExpanded ? "Read less" : "Read more"}
                      </span>
                    )}
                  </p>
                </li>
              </ul>

              <ul className="col-md-3 col-sm-6 footer-widget-container">
                <li className="widget widget_pages">
                  <div className="title">
                    <h3>Site Map</h3>
                  </div>

                  <ul>
                    <li>
                      <Link to="/" style={{ textDecoration: "none" }}>
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link to="/about" style={{ textDecoration: "none" }}>
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link to="/product" style={{ textDecoration: "none" }}>
                        Our Product
                      </Link>
                    </li>
                    <li>
                      <Link to="/trade" style={{ textDecoration: "none" }}>
                        Trade with us
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact" style={{ textDecoration: "none" }}>
                        Enquire Now
                      </Link>
                    </li>
                    {/* <li>
                      <Link to="/" style={{textDecoration:'none'}}>Technology</Link>
                    </li> */}
                  </ul>
                </li>
              </ul>

              <ul className="col-md-3 col-sm-6 footer-widget-container">
                <li className="widget widget_pages">
                  <div className="title">
                    <h3>PRODUCTS</h3>
                  </div>

                  <ul>
                    <li>
                      <Link to="/" style={{ textDecoration: "none" }}>
                        G4 Banana
                      </Link>
                    </li>
                    <li>
                      <Link to="/" style={{ textDecoration: "none" }}>
                        Green Chilli
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>

              <ul className="col-md-3 col-sm-6 footer-widget-container">
                <li className="widget widget-text">
                  <div className="title">
                    <h3>CONTACT DETAILS</h3>
                  </div>

                  <address>
                  RBC Infrastructure Pvt.Ltd., India
                    {/* R B Corporation
                    <br />
                    House no. 46, Beldarpara Road <br />
                    P.O: Tura, West Garo Hills Meghalaya,
                    <br />
                    India , Pincode - 794001 */}
                  </address>

                  <span className="text-big">+91 7005205341 </span>
                  <br />

                  <a
                    href="mailto:export@rbcorporations.com"
                    style={{ textDecoration: "none" }}
                  >
                    export@rbcil.com
                  </a>
                  <br />
                  <br />
                  <Link to="/" style={{ textDecoration: "none" }}>
                    JOIN US ON SOCIAL
                  </Link>

                  <br />
                  <ul className="footer-social-icons">
                    <li>
                      <Link
                        to="/"
                        target="_blank"
                        className="fa fa-facebook"
                        style={{ textDecoration: "none" }}
                      ></Link>
                    </li>
                    <li>
                      <Link
                        to="/"
                        target="_blank"
                        className="fa fa-instagram"
                        style={{ textDecoration: "none" }}
                      ></Link>
                    </li>

                    <li>
                      <Link
                        to="/"
                        target="_blank"
                        className="fa fa-linkedin"
                        style={{ textDecoration: "none" }}
                      ></Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </footer>

        <div className="copyright-container">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <p>© 2025 RBC Infrastructure Pvt. Ltd.</p>
              </div>

              <div className="col-md-6">
                <p className="align-right">
                  <Link
                    to="/"
                    style={{ textDecoration: "none" }}
                    target="_blank"
                  >
                    <img
                      src="https://rbcorporationexport.netlify.app/assets/logo.png"
                      width="45"
                      style={{ float: "right" }}
                      alt=""
                    />
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>

        <Link to="/#" className="scroll-up" style={{ textDecoration: "none" }}>
          Scroll
        </Link>
      </div>
    </div>
  );
};

export default Footer;
